import React from 'react';
import KonamiCode from 'konami-code';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';

import { version } from 'common/config/config';

const StyledRow = styled.p`
  display: 'flex', 
  margin: 'auto', 
  padding: '10px 0'
`;

export class VersionComponent extends React.Component {
  konami = new KonamiCode();
  state = { open: false };

  constructor() {
    super();

    this.konami.listen(() => {
      this.setState({ open: true });
    });
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const actions = [
      <FlatButton
        key="OkThanks"
        label="Ok, Thanks"
        primary
        onClick={this.handleClose}
      />,
    ];

    return (
      <Dialog
        actions={actions}
        modal={false}
        title={'Version Information'}
        open={this.state.open}
        onRequestClose={this.handleClose}
      >
        <div className={'row'}>
          <StyledRow>
            Commit #: {version.hashCommit}
          </StyledRow>
        </div>
        <div className={'row'}>
          <StyledRow>
            Tag Name: {version.tagName}
          </StyledRow>
        </div>
        <div className={'row'}>
          <StyledRow>
            Deploy Date Time: {version.dateTime}
          </StyledRow>
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/VersionComponent.js